import { render } from "./WelcomePatientScreen.vue?vue&type=template&id=46cb5ec2&scoped=true"
import script from "./WelcomePatientScreen.vue?vue&type=script&lang=js"
export * from "./WelcomePatientScreen.vue?vue&type=script&lang=js"

import "./WelcomePatientScreen.vue?vue&type=style&index=0&id=46cb5ec2&scoped=true&lang=css"

import exportComponent from "/srv/m1port/dev/client/patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46cb5ec2"]])

export default __exports__